import { render, staticRenderFns } from "./CommentsListModal.vue?vue&type=template&id=b0e22bf0"
import script from "./CommentsListModal.vue?vue&type=script&lang=js"
export * from "./CommentsListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports